module.exports = __webpack_public_path__ + "img/forecasting.3fe99441.png";